import { RegisterSectionsQuery } from '../../course_scheduler/queries/register_sections_query';

class TermInfoController {
  constructor(private ngRegisterSectionsQuery: RegisterSectionsQuery) {}
}

angular.module('capability-ng-scheduler').component('termInfo', {
  templateUrl: 'capability-ng-scheduler/src/views/aside/term_info/term_info.html',
  controller: TermInfoController
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/aside/term_info/term_info.ts